import React, { Component } from 'react';
// import './App.css';
import Body from "./components/body/body";

class App extends Component {
  render() {
    return (
      <div>
      <Body />
      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js